import React, {Component} from 'react';
import ExpiredPriceNotice from "./ExpiredPriceNotice";

export default class ExpiredPriceNoticeContainer extends Component {
    render() {
        return (
            <ExpiredPriceNotice
                translations={this.props.translations}
                noticeParameters={this.props.noticeParameters}
            />
        );
    }
}

export const DOMAIN = 'expired_price_notice';



// WEBPACK FOOTER //
// ./src/components/ExpiredPriceNoticeContainer.js